import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ItemsService} from 'app/commons/items.service';

@Injectable({
    providedIn: 'root'
})
export class FormsService extends ItemsService{


    constructor(public http2: HttpClient) {
        super(http2);
    }
    
    getServiceName(){
        return 'form';
    }
    getRoles() {
        return this.http2.get<any>(ItemsService.API_URL+'role')
            .toPromise()
            .then(res => <any[]> res);
    }
    

}
